export const footer_i18n = {
    text1: "Privacidade",
    text2: "Termos",
    text3: "Mapa do site"
};
